import { render, staticRenderFns } from "./defineForm.vue?vue&type=template&id=bb3d29c0&"
import script from "./defineForm.vue?vue&type=script&lang=js&"
export * from "./defineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports